<div class="flex flex-col md:flex-row gap-4">
  <!-- sidebar -->
  <div class="sidebar-calendary md:w-[20%] p-6">

    <div class="flex py-3">
      <div class="btn-group h-10 w-full flex items-center justify-between">
        <!-- col-2 -->
        <div class="col-md-10 mx-0">
          <div class=" text-gray-500 flex items-center justify-start bg-white ">
            <h3 class="text-gray-700 text-lg pt-1 mb-0 " style="color:white !important;">{{ viewDate |
              calendarDate:(monthView + 'ViewTitle'):language }}</h3>
          </div>
        </div>

        <!-- Flecha 1 -->
        <div class="col-md-2 flex-row flex justify-end items-center mx-0">
          <div
            class="btn-icon cursor-pointer text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-start  bg-white "
            mwlCalendarPreviousView [view]="monthView" [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange($event)">
            <i class="fa-solid fa-chevron-left w-5 h-5 text-gray-400"></i>
          </div>
          <!-- Flecha 2 -->
          <div
            class="btn-icon cursor-pointer text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-end   bg-white "
            mwlCalendarNextView [view]="monthView" [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange($event)">
            <i class="fa-solid fa-chevron-right w-5 h-5 text-gray-400"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- <mwl-calendar-month-view id="calendary-sidebar"
      [viewDate]="viewDate"
      [events]="[]"
      [activeDayIsOpen]="false"
      (dayClicked)="onSidebarDateSelected($event.day)">
    </mwl-calendar-month-view> -->
    <mwl-calendar-month-view id="calendary-sidebar" [viewDate]="viewDate" [locale]="language" [events]="events" [refresh]="refresh"
      [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)"
      (viewDateChange)="onViewDateChange($event)"
      (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)">
    </mwl-calendar-month-view>

    <div class="flex flex-row items-center gap-2 py-3 my-4 w-full border-t border-b border-[#606060]">
      <p class="mb-0" style=" color: white;">{{"words.today" | translate}} </p> <span class="opacitfy-50" style="color: white;">{{today}}</span>
    </div>

  </div>
  <!-- calendary dashboard -->
  <div class="w-100 lg:w-[76%] p-6">
    <div class="py-3 flex gap-2 justify-between ">
      <!-- Flecha atras -->
      <div class="flex items-center " (click)="goBack()">
        <div class="flex flex-row">
          <button class="text-gray-500 relative w-8 h-8 hover:text-gray-700 ">
            <i
              class="icon icon-arrow-left-1 w-5 h-5 text-gray-400 flex align-center justify-center text-lg hover:text-gray-700"></i>
          </button>
        </div>
        <div class="flex items-center ">
          <a class="text-gray-500 hover:text-gray-700 text-md mb-0">{{"academy.calendar-go-back" | translate}}</a>
        </div>
      </div>
      <!-- btn eventos -->
      <div class="flex items-center">

        <span class="hidden mb-0 text-lg items-center  text-gray-700">
          {{"academy.calendar-edit-event" | translate}}</span>
        <button class="btn-calendary btn-transition flex items-center py-2 px-3 rounded-[8px] flex"
                (click)="openNewEvent()">
          <i class="icon icon-plus-circle w-5 h-5 text-white flex align-center justify-center text-lg hover:text-gray-700"></i>
          <span class="text-sm mx-2">{{"academy.calendar-add-event" | translate}}</span>
        </button>
        <!-- <button class="btn-calendary btn-transition flex items-center py-2 px-3 rounded-[8px] flex"
          (click)="openModal()">
          <i
            class="icon icon-plus-circle w-5 h-5 text-white flex align-center justify-center text-lg hover:text-gray-700 "></i>
          <span class="text-sm mx-2">Add Event </span>
        </button> -->
        <div class="clearfix"></div>

      </div>
    </div>
    <!-- Header -->
    <div class="card-academy rounded-[14px] flex flex-col md:flex-row text-center border border-gray-100 justify-between px-6 ">
      <!-- Col 1 Mes en letra-->
      <div class="col-md-4">

        <div class="btn-group h-10 w-full flex items-center justify-between">
          <!-- Flecha 1 -->
          <div class="btn-icon cursor-pointer text-gray-500 flex items-center justify-start  bg-white "
            mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange($event)">
            <i class="fa-solid fa-chevron-left w-5 h-5 text-gray-400"></i>
          </div>

          <!-- col-2 -->
          <div class="col-md-8 mx-0">
            <div class=" text-gray-500 flex items-center justify-center bg-white ">
              <h3 class="text-gray-700 text-lg pt-1 mb-0">{{ viewDate | calendarDate:(view + 'ViewTitle'):language }}</h3>
            </div>
          </div>

          <!--hidden today-->

          <!--hidden today
      <div class="hidden btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">
        Today
      </div>-->

          <!-- Flecha 2 -->
          <div class="btn-icon cursor-pointer text-gray-500  flex items-center justify-end   bg-white "
            mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange($event)">
            <i class="fa-solid fa-chevron-right w-5 h-5 text-gray-400"></i>
          </div>
        </div>
      </div>

      <!-- Col 2 buttons Mes -->
      <div class="col-md-4">
        <div class="btn-group h-10 flex md:justify-content-end gap-2">
          <!--
          <div class="cursor-pointer text-gray-500 relative  flex items-center justify-center"
            (click)="setView(CalendarView.Month)" [class.active]="view === CalendarView.Month">
            Month
          </div>
          -->
          <div class="cursor-pointer text-gray-500 relative  flex items-center justify-center "
            (click)="setView(CalendarView.Week)" [class.active]="view === CalendarView.Week">
            {{"words.week" | translate}}
          </div>
          <div class="cursor-pointer text-gray-500 relative  flex items-center justify-center "
            (click)="setView(CalendarView.Day)" [class.active]="view === CalendarView.Day">
            {{"words.day" | translate}}
          </div>
        </div>
      </div>
    </div>
    <!-- Dashboard -->
    <div class="rounded-[14px]  border border-gray-100 p-6 my-4"
      style="background-color: white; box-shadow:0px 4px 8px 3px rgba(0, 0, 0, 0.04)">
      <div [ngSwitch]="view">
        <!--
        <mwl-calendar-month-view id="calendary-dash" *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate"
          [events]="events" [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen"
          (dayClicked)="dayClicked($event.day)" (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)">
        </mwl-calendar-month-view>
        -->
        <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week"  [viewDate]="viewDate" [locale]="language" [events]="events"
          [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)">
          <!--(viewDateChange)="onViewDateChange($event)-->
        </mwl-calendar-week-view>
        <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [locale]="language" [events]="events"
          [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)">
          <!--(viewDateChange)="onViewDateChange($event)-->
        </mwl-calendar-day-view>
      </div>
    </div>
  </div>
</div>
 <ng-container *ngIf="showModal">
  <app-event-modal
    [eventData]="selectedEvent"
    (close)="showModal = false"
    (save)="onSaveEvent($event)">
  </app-event-modal>
</ng-container>

<!-- Modal events-->
<!-- <msc-common-modal size="100%" #modalContent [title]="'words.logout' | translate">
  
  <ng-template>
    <div class="flex gap-2 justify-between mb-2" style="margin-top: -1rem;">
      <div class="flex items-center">
        <h3 class=" mb-0 text-lg items-center  text-gray-700">
          {{"academy.calendar-edit-event" | translate}}
        </h3>
      </div>
      <div class="flex items-center">
        <button class="btn-modal-events float-end btn-transition " (click)="addEvent()"><i
            class="icon icon-plus-circle w-5 h-5 text-white flex align-center justify-start text-lg hover:text-gray-700 mr-2"></i>
          {{"academy.calendar-add-event" | translate}}
        </button>
        <div class="clearfix"></div>
      </div>
    </div>
  </ng-template>
</msc-common-modal> -->

<!-- <div
  *ngIf="isLoading"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
  <div class="text-center text-white">
    <div class="loader mb-4"></div>
    <p>{{"academy.calendar-loading" | translate}}</p>
  </div>
</div> -->
<div
  *ngIf="isLoading"
  class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm transition-opacity duration-300">
  <div class="flex flex-col items-center">
    <div class="loader-spinner mb-4"></div>
    <p class="text-black text-lg font-semibold">{{"academy.calendar-loading" | translate}}</p>
  </div>
</div>
